import { Box, Button, ClickAwayListener, Container, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { currentUserActions, stockParamsFormActions } from '../redux/store'
import axios from 'axios'
import { api } from '../utils/api'
import { handleError } from '../utils/error'
import { useNavigate } from 'react-router-dom'
import { getFromStorage } from '../utils/storage'
import { borderFormat, mainGreen, mainGrey, mainRed } from '../utils/color'

export default function StockParamsForm(props) {
	const { stockParams } = useSelector((state) => state.stockParamsForm)
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [stockParamsEdit, setStockParamsEdit] = useState({
		values: {
			maxCapacity: stockParams.maxCapacity,
			manufacturePlan: stockParams.manufacturePlan,
		},
		errors: { maxCapacity: '', manufacturePlan: '' },
	})

	const handleChange = (e) => {
		let { name, value } = e.target
		let newValue = { ...stockParamsEdit.values, [name]: value }
		let newError = { ...stockParamsEdit.errors }

		if (name === 'maxCapacity') {
			if (Number(value) <= 0 && value.trim() !== '') {
				newError[name] = '* Sức chứa tối đa phải lớn hơn 0!'
			} else {
				newError[name] = ''
			}
		}
		if (name === 'manufacturePlan') {
			if (Number(value) <= 0 && value.trim() !== '') {
				newError[name] = '* Kế hoạch sản xuất phải lớn hơn 0!'
			} else {
				newError[name] = ''
			}
		}

		setStockParamsEdit({ values: newValue, errors: newError })
	}

	const handleSubmit = async (event) => {
		event.preventDefault()
		const maxCapacity = stockParamsEdit.values.maxCapacity
		const manufacturePlan = stockParamsEdit.values.manufacturePlan
		if (String(maxCapacity).trim() === '' || String(manufacturePlan).trim() === '') {
			alert('Dữ liệu không được để trống')
			return
		}
		if (stockParamsEdit.errors.maxCapacity.trim() !== '' || stockParamsEdit.errors.manufacturePlan.trim() !== '') {
			return
		}
		try {
			await axios({
				url: api.EDIT_MAIN_STOCK,
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { maxCapacity, manufacturePlan },
			})
			await props.getMainStock()
			dispatch(stockParamsFormActions.hideStockParamsForm())
		} catch (err) {
			handleError(err)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}
	return (
		<ClickAwayListener
			onClickAway={() => {
				dispatch(stockParamsFormActions.hideStockParamsForm())
			}}>
			<Box>
				<Container
					onClick={(e) => {
						e.stopPropagation()
					}}
					onTouchEnd={(e) => {
						e.stopPropagation()
					}}
					sx={{
						background: mainGrey,
						borderTop: borderFormat,
						borderLeft: borderFormat,
						borderRight: borderFormat,
						maxWidth: '600px',
					}}
					maxWidth={false}>
					<Box noValidate display='flex' justifyContent='space-between' alignItems='center' sx={{ pt: 2 }}>
						{stockParamsEdit.errors.maxCapacity === '' ? (
							<Box sx={{ width: '48%' }}>
								<Typography
									sx={{
										textAlign: 'center',
										background: mainGreen,
										color: '#fff',
										padding: '3px 0',
										borderRadius: '3px',
									}}>
									Sức chứa tối đa
								</Typography>
								<TextField
									fullWidth
									type='number'
									value={stockParamsEdit.values.maxCapacity}
									sx={{
										mt: 1,
										background: '#fff',
									}}
									id='maxCapacity'
									label='kg'
									name='maxCapacity'
									autoComplete='maxCapacity'
									onChange={handleChange}
								/>
							</Box>
						) : (
							<Box sx={{ width: '48%' }}>
								<Typography
									sx={{
										textAlign: 'center',
										background: mainGreen,
										color: '#fff',
										padding: '3px 0',
										borderRadius: '3px',
									}}>
									Sức chứa tối đa
								</Typography>
								<TextField
									fullWidth
									type='number'
									value={stockParamsEdit.values.maxCapacity}
									sx={{
										mt: 1,
										background: '#fff',
									}}
									error
									id='maxCapacity'
									label='kg'
									name='maxCapacity'
									autoComplete='maxCapacity'
									onChange={handleChange}
								/>
							</Box>
						)}
						{stockParamsEdit.errors.manufacturePlan === '' ? (
							<Box sx={{ width: '48%' }}>
								<Typography
									sx={{
										textAlign: 'center',
										background: mainGreen,
										color: '#fff',
										padding: '3px 0',
										borderRadius: '3px',
									}}>
									Kế hoạch sản xuất
								</Typography>
								<TextField
									fullWidth
									type='number'
									value={stockParamsEdit.values.manufacturePlan}
									sx={{
										mt: 1,
										background: '#fff',
									}}
									id='manufacturePlan'
									label='Ngày'
									name='manufacturePlan'
									autoComplete='manufacturePlan'
									onChange={handleChange}
								/>
							</Box>
						) : (
							<Box sx={{ width: '48%' }}>
								<Typography
									sx={{
										textAlign: 'center',
										background: mainGreen,
										color: '#fff',
										padding: '3px 0',
										borderRadius: '3px',
									}}>
									Kế hoạch sản xuất
								</Typography>
								<TextField
									fullWidth
									type='number'
									value={stockParamsEdit.values.manufacturePlan}
									sx={{
										mt: 1,
										background: '#fff',
									}}
									error
									id='manufacturePlan'
									label='Ngày'
									name='manufacturePlan'
									autoComplete='manufacturePlan'
									onChange={handleChange}
								/>
							</Box>
						)}
					</Box>
					{stockParamsEdit.errors.maxCapacity && (
						<Typography sx={{ color: '#ff0000' }}>{stockParamsEdit.errors.maxCapacity}</Typography>
					)}
					{stockParamsEdit.errors.manufacturePlan && (
						<Typography sx={{ color: '#ff0000' }}>{stockParamsEdit.errors.manufacturePlan}</Typography>
					)}
					<Box>
						<Button
							fullWidth
							type='button'
							variant='contained'
							sx={{
								mt: 2,
								mb: 2,
								background: mainRed,
								'&:hover': { background: mainRed },
							}}
							onClick={(e) => {
								handleSubmit(e)
							}}>
							Xác nhận
						</Button>
					</Box>
				</Container>
			</Box>
		</ClickAwayListener>
	)
}
